import React from "react";
import { withNavBars } from "../../HOCs";
import InternalLeadSource from "./internalLeadSource";

class InternalLeadSourceParent extends React.Component {
  render() {
    return <InternalLeadSource {...this.props} />;
  }
}

const props = {
  boxShadow: false
}

export default withNavBars(InternalLeadSourceParent, props);
